export { default } from "./GlobalCta";
export * from "./GlobalCta";
export * from "./GlobalCta.model";
